<template>
    <div class="task-calendar">
        <div class="addNewTask" @click.stop="addTask()">
            <!-- 新增任务 -->
            <i class="el-icon-plus"></i> {{ $t('taskPage.taskCalendar.addTask') }}
        </div>
        <div class="colorTag">
            <span class="colorTag_left tag-starting"></span> <span>{{ $t('taskPage.taskCalendar.executing') }}</span>
            <span class="colorTag_left tag-unstart"></span> <span>{{ $t('taskPage.taskCalendar.pendingExecution') }}</span>
            <span class="colorTag_left tag-started"></span> <span>{{ $t('taskPage.taskCalendar.pendingUploadData') }}</span>
            <!-- <span class="colorTag_left tag-result"></span> <span> 结果处理中</span> -->
            <span class="colorTag_left tag-end"></span> <span>{{ $t('taskPage.taskCalendar.completed') }}</span>
            <span class="colorTag_left tag-stop"></span> <span>{{ $t('taskPage.taskCalendar.terminated') }}</span>
        </div>
        <el-date-picker
            v-if="showDateChangeItem"
            ref="datePicker"
            class="changeItemDate"
            v-model="changeDateValue"
            type="month"
            @change="getChangeDate"
            :placeholder="$t('taskPage.taskCalendar.selectMonth')"
            popper-class="mydata"
        >
        </el-date-picker>
        <el-calendar ref="calendar" v-model="currentDate">
            <template slot="dateCell" slot-scope="{ date, data }">
                <div
                    class="taskMouth"
                    :class="{ taskDay: data.day === showTaskDay }"
                    @contextmenu.prevent="addTask(data.day)"
                    @click="nullClick"
                    style="height: 100%; width: 100%"
                >
                    <div class="dateNum">
                        <span>
                            {{ data.day.split('-')[2] }}&nbsp;
                            <i
                                style="
                                    background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
                                    font-size: 14px;
                                    color: black;
                                    padding: 0 5px;
                                "
                                v-show="data.day === curDate"
                                >{{ $t('taskPage.taskCalendar.today') }}</i
                            ></span
                        >
                        <span @click.stop="showTaskList(data.day)">
                            <span
                                v-show="
                                    taskDayObj[data.day.split('-')[2]] > 2 && data.type == 'current-month'
                                "
                                class="taskdayTitle"
                            >
                                {{ $t('taskPage.taskCalendar.total') }} {{ taskDayObj[data.day.split('-')[2]] }} {{ $t('taskPage.taskCalendar.totalCount') }}
                            </span>
                            <img
                                v-if="
                                    taskDayObj[data.day.split('-')[2]] > 2 &&
                                    data.type == 'current-month' &&
                                    showTaskDay !== data.day
                                "
                                class="taskdayTitle-right"
                                src="../imgs/more-2-line.png"
                            />
                            <i
                                class="el-icon-close taskdayTitle-right"
                                v-if="
                                    taskDayObj[data.day.split('-')[2]] > 2 &&
                                    data.type == 'current-month' &&
                                    showTaskDay === data.day
                                "
                            ></i>
                        </span>
                    </div>
                    <div class="taskContent">
                        <div
                            style="width: 200"
                            v-for="(item, index) in table[data.day.split('-')[2]]"
                            :key="item.id"
                            :ref="`bt${data.day.split('-')[2]}${index}`"
                        >
                            <div
                                :class="{
                                    'is-none': item.planStartTime.split(' ')[0] !== data.day,
                                    'task-unstart': item.taskStatus == 1,
                                    'task-starting': item.taskStatus == 2,
                                    'task-started': item.taskStatus == 3 || item.taskStatus == 4,
                                    'task-end': item.taskStatus == 5,
                                    'task-stop': item.taskStatus == 6,
                                }"
                                @click.stop="showOperation(item, `bt${data.day.split('-')[2]}${index}`)"
                                class="task-des"
                            >
                                <CustomMarquee :duration="5" deb style="font-size: 14px">
                                    <img src="../imgs/item.png" />
                                    {{ item.name }}
                                </CustomMarquee>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </el-calendar>
        <div v-if="resultShow" class="result-task">
            <TaskResult
                @dialogClose="dialogClose"
                @refresh="updateTaskData"
                :stopStatus="stopStatus"
                :data="ResultDataObj"
            />
        </div>
        <el-popover
            placement="top"
            popper-class="calendar-tips"
            v-if="showEditDetail"
            ref="pop"
            :reference="reference"
            width="250"
            trigger="click"
        >
            <div style="display: flex;">
                <div
                    class="task-info-box"
                    v-has="'fcs:task:query'"
                    v-if="dataItem.taskStatus == 5"
                    @click.stop="historyVideo(dataItem)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.historyPlayback')" placement="top">
                        <div class="cell-img borderRight img-history"></div>
                    </el-tooltip>
                </div>
                <div
                    v-has="'fcs:task:edit'"
                    class="task-info-box"
                    v-if="dataItem.taskStatus == 3"
                    @click.stop="taskOver(dataItem)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.completeUpload')" placement="top">
                        <div class="cell-img borderRight img-endUpload"></div>
                    </el-tooltip>
                </div>
                <!-- <div
                    v-has="'fcs:task:edit'"
                    class="task-info-box"
                    v-if="dataItem.taskStatus == 3"
                    @click.stop="uploadTaskData(dataItem)"
                >
                    <el-tooltip
                        effect="dark"
                        popper-class="icon-tooltip"
                        :content="$t('taskPage.taskCalendar.uploadFlightData')"
                        placement="top"
                    >
                        <div class="cell-img borderRight img-uploadFly"></div>
                    </el-tooltip>
                </div> -->
                <!-- <div class="task-info-box" v-if="dataItem.taskStatus == 4" @click.stop="resultUpload(dataItem)">
                    <el-tooltip effect="dark" popper-class="icon-tooltip" content="上传结果" placement="top">
                        <div class="cell-img borderRight img-upload"></div>
                    </el-tooltip>
                </div> -->

                <div
                    class="task-info-box"
                    v-has="'fcs:control:cmd'"
                    v-if="dataItem.model == 1 && dataItem.taskStatus == 1"
                    @click.stop="confirmTask(dataItem)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.confirmTask')" placement="top">
                        <div class="cell-img borderRight img-confirm"></div>
                    </el-tooltip>
                </div>
                <div
                    class="task-info-box"
                    v-has="'fcs:control:cmd'"
                    v-if="dataItem.model != 1 && (dataItem.taskStatus == 1 || dataItem.taskStatus == 2)"
                    @click.stop="openFlightControlPage(dataItem)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.startExecution')" placement="top">
                        <div class="cell-img borderRight img-control"></div>
                    </el-tooltip>
                </div>
                <!-- <div class="task-info-box" v-if="dataItem.taskStatus == 5" @click.stop="toResult(dataItem)">
                    <el-tooltip effect="dark" content="查看结果" popper-class="icon-tooltip" placement="top">
                        <div class="cell-img borderRight img-result"></div>
                    </el-tooltip>
                </div> -->
                <div
                    class="task-info-box"
                    v-has="'fcs:control:cmd'"
                    v-if="dataItem.taskStatus == 6"
                    @click.stop="stopRea(dataItem, true)"
                >
                    <el-tooltip effect="dark" :content="$t('taskPage.taskCalendar.terminateReason')" popper-class="icon-tooltip" placement="top">
                        <div class="cell-img borderRight img-stop"></div>
                    </el-tooltip>
                </div>
                <div class="task-info-box" @click.stop="detail(dataItem)">
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.detail')" placement="top">
                        <div class="cell-img borderRight img-detail"></div>
                    </el-tooltip>
                </div>
                <div
                    class="task-info-box"
                    v-has="'fcs:task:edit'"
                    v-if="Number(dataItem.taskStatus) > 2"
                >
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('taskPage.taskCalendar.dataCorrection')"
                        placement="top"
                        popper-class="icon-tooltip"
                    >
                        <div class="cell-img borderRight img-editor" @click="editTask(dataItem)"></div>
                    </el-tooltip>
                </div>
                <div
                    @click.stop="editTask(dataItem)"
                    class="task-info-box"
                    v-has="'fcs:task:edit'"
                    v-if="Number(dataItem.taskStatus) < 2"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.edit')" placement="top">
                        <div class="cell-img borderRight img-editor"></div>
                    </el-tooltip>
                </div>
                <div class="task-info-box" v-has="'fcs:task:edit'" @click.stop="copyTask(dataItem.id)">
                    <el-tooltip effect="dark" :content="$t('taskPage.taskCalendar.copy')" popper-class="icon-tooltip" placement="top">
                        <div class="cell-img borderRight img-copy"></div>
                    </el-tooltip>
                </div>
                <div
                    class="task-info-box"
                    v-has="'fcs:task:remove'"
                    v-if="dataItem.taskStatus != '2'"
                    @click.stop="clearTask(dataItem.id)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.delete')" placement="top">
                        <div class="cell-img borderRight img-clear"></div>
                    </el-tooltip>
                </div>
                <div
                    class="task-info-box"
                    v-has="'fcs:control:cmd'"
                    v-if="dataItem.taskStatus == 2"
                    @click.stop="taskEnd(dataItem)"
                >
                    <el-tooltip effect="dark" popper-class="icon-tooltip" :content="$t('taskPage.taskCalendar.endExecution')" placement="top">
                        <div class="cell-img borderRight img-end"></div>
                    </el-tooltip>
                </div>
                <div
                    class="task-info-box"
                    v-has="'fcs:control:cmd'"
                    v-if="dataItem.taskStatus == 2"
                    @click.stop="taskStop(dataItem)"
                >
                    <el-tooltip effect="dark" :content="$t('taskPage.taskCalendar.terminateTask')" popper-class="icon-tooltip" placement="top">
                        <div class="cell-img borderRight img-terani"></div>
                    </el-tooltip>
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';

import VXETable from 'vxe-table';
import $ from 'jquery';
import api from '../api';
import { addDateRange } from '@/utils/common.js';

import TaskResult from '../common/TaskResult.vue';
import CustomMarquee from '@/page/mainPage/components/CustomMarquee/CustomMarquee.vue';

export default {
    components: {
        TaskResult,
        CustomMarquee,
        YScroll,
    },
    props: {
        saveTime: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isSelected: false,
            showEditDetailo: false,
            MouthData: [],
            hasDate: '',
            stopStatus: false,
            table: {},
            searchObj: {},
            reference: {},
            // 控制渲染条件 如果不用v-if会报错 具体可自行尝试
            showEditDetail: false,
            // 保存当前激活的refrence id
            activeId: '',
            showDateChangeItem: false,
            showTaskDay: '',
            activeOperation: '',
            showIndex: -1,
            showName: '',
            taskDayObj: {},
            tagIndex: -1,
            resultShow: false,
            showTip: false,
            target: '',
            currentDate: '',
            changeDateValue: '',
            hasAdd: true,
            mouth: new Date(),
            dataItem: {},
            ResultDataObj: {
                id: '',
                taskStatus: '',
                type: 0,
            },
        };
    },
    computed: {
        curDate() {
            let data = new Date();
            let day = data.getDate();
            let month = data.getMonth() + 1;
            let year = data.getFullYear();
            if (day < 10) day = `0${day}`;
            if (month < 10) month = `0${month}`;
            data = `${year}-${month}-${day}`;
            return data;
        },
        appCode() {
            // 取当前所属应用，优先从路由参数中取，如果没有再从localStorage中取
            let appCode = this.$route.query.appCode || localStorage.getItem('appCode') || '';
            // console.log('appCode',appCode)
            return appCode;
        },
    },
    mounted() {
        // $('.el-calendar__title')[0].addEventListener('click', this.showChangeDate);
        // console.log(dateMounth, '获取的元素');
        let { calendarDate } = this.$store.state.Common.PageBackObj;
        this.currentDate = calendarDate || '';
        this.getTableData(this.currentDate || this.mouth);
    },
    methods: {
        showTaskList(el) {
            if (this.showTaskDay) {
                this.showTaskDay = '';
            } else {
                this.showTaskDay = el;
            }
        },
        getChangeDate(el) {
            console.log('选择的日期', el, this.currentDate);
            this.showDateChangeItem = false;
            this.currentDate = el;
        },
        showChangeDate() {
            console.log('点击事件');
            this.showDateChangeItem = !this.showDateChangeItem;
            this.$nextTick(() => {
                this.$refs.datePicker.focus();
                $('.changeItemDate').find('input').hide();
                $('.changeItemDate').find('.el-input__prefix').hide();
                $('.changeItemDate').find('.el-input__suffix').hide();
            });
        },
        getTableData(newVal) {
            // if (newVal) {
            let amouth = newVal.getMonth() + 1;
            let ayear = newVal.getFullYear();
            let adate = new Date(ayear, amouth, 0).getDate();
            this.searchObj = addDateRange(
                this.searchObj,
                [`${ayear}-${amouth}-1`, `${ayear}-${amouth}-${adate}`],
                'plan',
            );
            this.searchObj.appCode = this.appCode;
            api.getPageList(this.searchObj).then((e) => {
                if (e.rows.length > 0) {
                    let data = {};
                    for (let i = 1; i < 32; i++) {
                        if (i < 10) i = `0${i}`;
                        data[i] = [];
                    }
                    let taskDayArr = [];
                    e.rows.forEach((item) => {
                        let day = item.planStartTime && item.planStartTime.substr(0, 10).split('-')[2];
                        taskDayArr.push(day);
                        // console.log(day, data, 'aaa')
                        data[`${day}`].push({ ...item, show: false });
                    });
                    this.table = data;
                    this.taskDayObj = {};
                    for (let i = 0; i < taskDayArr.length; i++) {
                        let key = taskDayArr[i];
                        if (this.taskDayObj[key] === undefined) {
                            this.taskDayObj[key] = 1;
                        } else {
                            this.taskDayObj[key]++;
                        }
                    }
                } else {
                    this.table = {};
                    this.taskDayObj = {};
                }
            });
        },
        detail(el) {
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'first',
                    controls: 'detail',
                },
            });
            this.$emit('SaveCalendPage', this.mouth);
        },
        updateTaskData() {
            this.$emit('refresh');
        },
        dialogClose() {
            this.ResultDataObj = {};
            this.resultShow = false;
        },

        async openFlightControlPage(el) {
            // 实时直播
            VXETable.modal.confirm(this.$t('taskPage.taskCalendar.confirmFlightControl')).then((type) => {
                if (type === 'confirm') {
                    this.$router.push({
                        path: 'console',
                        query: {
                            type,
                            taskId: el.taskId,
                            dockId: el.dockId,
                            uavCode: el.droneId,
                            page: 'task',
                            selectType: 3,
                        },
                    });
                    this.$emit('SaveCalendPage', this.mouth);
                }
            });
        },
        resultUpload(el) {
            // 上传结果
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    routeId: el.routeId,
                    siteId: el.siteId,
                    status: el.taskStatus,
                    type: el.applyName,
                    page: 'fourth',
                },
            });
            this.$emit('SaveCalendPage', this.mouth);
        },
        async uploadTaskData(el) {
            if (el.planId) {
                // 上传数据
                this.$store.commit('SET_UPLOADOBJ', {
                    uploadVisible: true,
                    planId: el.planId,
                    routeId: el.routeId || '',
                });
            } else {
                this.$message.error(this.$t('taskPage.uploadFlyData.noFlightRecord'));
            }
        },
        confirmTask(data) {
            this.$emit('taskHandle', { data, eve: 'ConfirmTask' });
        },
        addTask(T = '') {
            this.$emit('add', T);
        },
        async historyVideo(el) {
            // 历史回放
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'third',
                },
            });
            this.$emit('SaveCalendPage', this.mouth);
        },
        taskOver(data) {
            this.$emit('taskHandle', { data, eve: 'taskOver' });
        },
        taskStop(data) {
            this.$emit('taskHandle', { data, eve: 'taskStop' });
        },
        taskEnd(data) {
            this.$emit('taskHandle', { data, eve: 'taskEnd' });
        },
        // 删除
        clearTask(el) {
            VXETable.modal.confirm(this.$t('taskPage.taskCalendar.deleteConfirm'), this.$t('taskPage.taskCalendar.deleteConfirmTitle'), {
                confirmButtonText: this.$t('taskPage.taskCalendar.deleteConfirmConfirm'),
                cancelButtonText: this.$t('taskPage.taskCalendar.deleteConfirmCancel'),
            }).then((type) => {
                if (type === 'confirm') {
                    api.deleteTask(el)
                        .then((v) => {
                            if (v.code == 200) {
                                this.$message.success(this.$t('taskPage.taskCalendar.deleteTaskSuccess'));
                                this.getTableData(this.currentDate || this.mouth);
                            }
                        })
                        .catch((err) => {
                            this.$message(this.$t('taskPage.taskCalendar.deleteTaskFailed'));
                        });
                }
            });
        },
        // 修改
        editTask(el) {
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    page: 'first',
                    controls: 'edit',
                },
            });
            this.$emit('SaveCalendPage', this.mouth);
        },
        copyTask(el) {
            api.copyTask(el)
                .then((v) => {
                    if (v.code == 200) {
                        this.$message.success(this.$t('taskPage.taskCalendar.copyTaskSuccess'));
                        this.getTableData(this.currentDate || this.mouth);
                    } else {
                        this.$message(this.$t('taskPage.taskCalendar.copyTaskFailed'));
                    }
                })
                .catch((err) => {});
        },
        async stopRea(el, status) {
            console.log(el, 'stop');
            this.resultShow = true;
            this.stopStatus = status;
            this.ResultDataObj.stopRead = el.stopReason;
            this.ResultDataObj.type = 2;
        },
        toResult(el) {
            this.$router.push({
                path: '/taskDetail',
                query: {
                    taskId: el.id,
                    routeId: el.routeId,
                    siteId: el.siteId,
                    status: el.taskStatus,
                    page: 'five',
                },
            });
            this.$emit('SaveCalendPage', this.mouth);
        },
        nullClick() {
            this.$nextTick(() => {
                this.showEditDetail = false;
            });
        },
        showOperation(e, r) {
            // 操作
            this.dataItem = e;
            if (this.activeId === e.id && this.showEditDetail) {
                this.$nextTick(() => {
                    this.showEditDetail = false;
                });
                return;
            }
            this.showEditDetail = false;
            this.activeId = e.id;
            this.reference = this.$refs[r][0];
            this.$nextTick(() => {
                this.showEditDetail = true;
                this.$nextTick(() => {
                    this.$refs.pop.doShow();
                });
            });
        },
        mouseleave(i) {
            // 鼠标离开隐藏功能操作
            // eslint-disable-next-line array-callback-return
            // this.table.filter((item, index) => {
            //     if (index === i) {
            //         this.$set(item, 'show', false);
            //     }
            // });
        },
    },
    watch: {
        currentDate: {
            handler(newVal) {
                if (newVal.getMonth() !== this.mouth.getMonth()) {
                    this.showTaskDay = '';
                    this.mouth = newVal;
                    this.table = {};
                    this.getTableData(newVal);
                    this.taskDayObj = {};
                }
            },
        },

        saveTime() {
            this.taskDayObj = {};
            this.table = {};
            this.getTableData(this.currentDate || this.mouth);
        },
    },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0);
    box-shadow: 8px 0 0 rgba(46, 125, 248, 0.6) inset;
}

::-webkit-scrollbar-thumb:hover {
    box-shadow: 8px 0 0 rgba(46, 125, 248, 0.6) inset;
}
</style>

<style lang="scss">
@import '../common/css/borderRight.css';
.el-popover .task-info-box.borderRight::after {
    width: 0 !important;
}
.taskMouth {
    .dateNum {
        position: relative;
        width: 100%;
        height: 16px;
        font-size: 16px;
        color: #fff;
        .taskdayTitle {
            position: absolute;
            right: 15px;
            font-size: 14px;
        }
        .taskdayTitle-right {
            position: absolute;
            right: 0px;
            top: -2px;
            font-size: 16px;
            // height: 14px;
        }
    }
    .taskContent {
        width: 100%;
        color: #fff;
        overflow-y: hidden;
        height: calc(100% - 28px);

        .task-des {
            // width: 96%;
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            margin: 3px 0 3px 0px;
            padding-left: 3px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            img {
                vertical-align: middle;
            }
        }
        .operation-line {
            position: absolute;
            top: 20px;
            right: 20px;
        }
        .task-starting {
            border-left: 3px solid rgba(92, 221, 120, 1);
            background: linear-gradient(
                90deg,
                rgba(92, 221, 120, 0.4) 0%,
                rgba(98, 236, 186, 0.17) 28%,
                rgba(98, 236, 186, 0.17) 66%,
                rgba(92, 221, 120, 0.4) 100%
            );
            border-image: linear-gradient(
                    90deg,
                    rgba(92, 221, 120, 0.8),
                    rgba(98, 236, 186, 0.25),
                    rgba(98, 236, 186, 0.25),
                    rgba(92, 221, 120, 0.8)
                )
                1 1;
        }
        .task-unstart {
            border-left: 3px solid rgba(255, 236, 61, 1);
            background: linear-gradient(
                90deg,
                rgba(255, 236, 61, 0.5) 0%,
                rgba(98, 236, 186, 0.17) 28%,
                rgba(98, 236, 186, 0.17) 66%,
                rgba(255, 236, 61, 0.5) 100%
            );
            border-image: linear-gradient(
                    90deg,
                    rgba(255, 236, 61, 0.8),
                    rgba(98, 236, 186, 0.25),
                    rgba(98, 236, 186, 0.25),
                    rgba(255, 236, 61, 0.8)
                )
                1 1;
        }
        .task-end {
            border-left: 3px solid rgba(73, 231, 253, 1);
            background: linear-gradient(
                90deg,
                rgba(73, 231, 253, 0.4) 0%,
                rgba(73, 231, 253, 0.17) 28%,
                rgba(73, 231, 253, 0.17) 66%,
                rgba(73, 231, 253, 0.4) 100%
            );
            border-image: linear-gradient(
                    90deg,
                    rgba(73, 231, 253, 0.8),
                    rgba(73, 231, 253, 0.25),
                    rgba(73, 231, 253, 0.25),
                    rgba(73, 231, 253, 0.8)
                )
                1 1;
        }
        .task-stop {
            border-left: 3px solid rgba(81, 121, 158, 1);
            background: linear-gradient(
                260deg,
                rgba(81, 121, 158, 0.6) 0%,
                rgba(81, 121, 158, 0.25) 38%,
                rgba(81, 121, 158, 0.25) 65%,
                rgba(81, 121, 158, 0.6) 100%
            );

            border-image: linear-gradient(
                    260deg,
                    rgba(81, 121, 158, 0.8) 0%,
                    rgba(81, 121, 158, 0.25) 38%,
                    rgba(81, 121, 158, 0.25) 65%,
                    rgba(81, 121, 158, 0.8) 100%
                )
                1 1;
        }
        .task-started {
            border-left: 3px solid rgba(6, 136, 255, 1);
            background: linear-gradient(
                90deg,
                rgba(25, 89, 245, 0.6) 0%,
                rgba(25, 89, 245, 0.25) 38%,
                rgba(25, 89, 245, 0.25) 65%,
                rgba(25, 89, 245, 0.6) 100%
            );
            border-image: linear-gradient(
                    90deg,
                    rgba(25, 89, 245, 0.8) 0%,
                    rgba(25, 89, 245, 0.25) 38%,
                    rgba(25, 89, 245, 0.25) 65%,
                    rgba(25, 89, 245, 0.8) 100%
                )
                1 1;
        }
        .task-resulted {
            border-left: 3px solid rgba(109, 72, 255, 1);
            background: linear-gradient(
                90deg,
                rgba(109, 72, 255, 0.6) 0%,
                rgba(109, 72, 255, 0.25) 38%,
                rgba(109, 72, 255, 0.25) 65%,
                rgba(109, 72, 255, 0.6) 100%
            );
            border-image: linear-gradient(
                    90deg,
                    rgba(109, 72, 255, 0.8) 0%,
                    rgba(109, 72, 255, 0.25) 38%,
                    rgba(109, 72, 255, 0.25) 65%,
                    rgba(109, 72, 255, 0.8) 100%
                )
                1 1;
        }
        .is-none {
            display: none;
        }
    }
}
.taskDay {
    height: auto !important;
    max-height: 258px !important;
    overflow-y: auto;
    border: 1px solid #49f0fd;
    border-radius: 3px;
    background-color: #163f61;
    padding: 7px;
    position: relative;
    top: -8px;
    left: -8px;
    z-index: 200;
    .taskContent {
        overflow-y: auto;
        height: auto;
    }
}
.el-popper[x-placement^='top'] .popper__aritem::after {
    border-top-color: #49f0fd;
}
.calendar-tips {
    width: 100%;
    padding: 20px 0px 30px 10px;
    background: rgba(7, 17, 80, 0.75);
    border: 0;
    background: url('../imgs/icon-mask-1.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .task-info-box {
        width: 24px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        // border-right: 1px solid rgba(255, 255, 255, 0.3);
        // padding: 0 2px 0 8px;
        margin: 0 5px;
        .cell-img {
            display: inline-block;
            margin: 0 8px;
            height: 20px;
            width: 20px;
            background-size: 20px 20px;
            cursor: pointer;
        }
        .img-clear {
            background-image: url('../imgs/delete-bin-line.png');
            &:hover {
                background-image: url('../imgs/delete-bin-line.bg.png');
            }
        }
        .img-copy {
            background-image: url('../imgs/file-copy-line.png');
            &:hover {
                background-image: url('../imgs/file-copy-line.bg.png');
            }
        }
        .img-result {
            background-image: url('../imgs/res.png');
            &:hover {
                background-image: url('../imgs/resbg.png');
            }
        }
        .img-stop {
            background-image: url('../imgs/stop.png');
            &:hover {
                background-image: url('../imgs/stopbg.png');
            }
        }
        .img-editor {
            background-image: url('../imgs/edit-box-line.png');
            &:hover {
                background-image: url('../imgs/edit-box-line.bg.png');
            }
        }
        .img-terani {
            background-image: url('../imgs/Mask group.png');
            &:hover {
                background-image: url('../imgs/Mask group.bg.png');
            }
        }
        .img-end {
            background-image: url('../imgs/jieshu 1.png');
            &:hover {
                background-image: url('../imgs/jieshu 2.png');
            }
        }

        .img-detail {
            background-image: url('../imgs/file-list-2-line.png') ;
            &:hover {
                background-image: url('../imgs/file-list-2-line.bg.png');
            }
        }
        .img-control {
            background-image: url('../imgs/zhibo1.png');
            &:hover {
                background-image: url('../imgs/zhibo.png');
            }
        }
        .img-start {
            background-image: url('../imgs/eject-fill.png');
            &:hover {
                background-image: url('../imgs/eject-fill.bg.png');
            }
        }
        .img-confirm {
            background-image: url('../imgs/confirm-color.png');
            &:hover {
                background-image: url('../imgs/confirm-bg.png');
            }
        }
        .img-upload {
            background-image: url('../imgs/folder-upload-line.png');
            &:hover {
                background-image: url('../imgs/folder-upload-line.bg.png');
            }
        }
        .img-uploadFly {
            background-image: url('../imgs/uploadFlyData.png');

            &:hover {
                background-image: url('../imgs/uploadData-bg.png');
            }
        }
        .img-endUpload {
            background-image: url('../imgs/end-upload-line.png');
            &:hover {
                background-image: url('../imgs/endbg-upload-line.png');
            }
        }
        .img-over {
            background-image: url('../imgs/check-double-line.png');
            &:hover {
                background-image: url('../imgs/check-double-line.bg.png');
            }
        }
        .img-history {
            background-image: url('../imgs/回放.png');
            &:hover {
                background-image: url('../imgs/回放2.png');
            }
        }
    }
}
.task-calendar {
    position: relative;
    border-radius: 3px 3px 3px 3px;
    opacity: 1;
    height: calc(100%);
    padding: 8px;
    border-top: 6px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 6px solid transparent;
    border-image: url(../imgs/bg_wrap.png) 10 10;
    .addNewTask {
        display: inline-block;
        width: 110px;
        height: 37px;
        line-height: 37px;
        color: #071150;
        text-align: center;
        background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
        border-radius: 2px;
        opacity: 1;
        border: 1px solid rgba(73, 240, 253, 0.4);
        position: absolute;
        top: 22px;
        right: 32px;
        cursor: pointer;
    }
    .colorTag {
        position: absolute;
        top: 29px;
        left: 16px;
        color: #fff;
        font-size: 14px;
        & > span {
            display: inline-block;
            vertical-align: middle;
        }
        .colorTag_left {
            width: 12px;
            height: 12px;
            margin-left: 8px;
        }
        .tag-unstart {
            background-color: #ffec3d;
        }
        .tag-starting {
            background-color: #5cdd78;
        }
        .tag-started {
            background-color: #0688ff;
        }
        .tag-result {
            background-color: #6d48ff;
        }
        .tag-end {
            background-color: #49e7fd;
        }
        .tag-stop {
            background-color: #51799e;
        }
    }
    .changeItemDate {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        // display: none;
    }
    .el-calendar {
        background-color: #15163d;
    }
    .el-calendar-table thead th {
        color: #fff;
        border: 1px solid #1a47a4;
        background-color: #112d7b;
        vertical-align: middle;
        font-size: 14px;
    }
    .el-calendar-table {
        position: relative;
        width: 100%;
        color: #fff;
        td.is-selected {
            background-color: #071150;
        }
        &:not(.is-range) {
            background-color: #071150;
            //使不是本月的日期不可点击，不会跳转到其他月份
            td.next {
                pointer-events: none;
            }
            td.prev {
                pointer-events: none;
            }
        }
    }
    .el-calendar-table .el-calendar-day {
        height: 11.3vh !important;
        padding: 8px 8px 0 8px !important;
    }
    .el-calendar-table .el-calendar-day:hover {
        background-color: #071150 !important;
        color: white;
    }
    .el-calendar-table td {
        border-bottom: 1px solid #1a47a4;
        border-right: 1px solid #1a47a4;
        vertical-align: top;
        transition: background-color 0.2s ease;
    }
    .el-calendar__header .el-calendar__title {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        font-size: 20px;
        color: #fff;
        border: none;
    }
    .el-calendar__body {
        padding: 0px !important;
    }
    .el-calendar__header {
        margin: 0 !important;
        border-bottom: none;
        height: 60px;
        line-height: 60px;
        padding: 0;
    }
    .el-calendar-table tr td:first-child {
        border-left: 1px solid #1a47a4;
    }
    .el-calendar-table td td.is-selected {
        border-bottom: 1px solid #112d7b;
        border-right: 1px solid #112d7b;
        vertical-align: top;
        transition: background-color 0.2s ease;
    }
    .el-calendar-table:not(.is-range) td.next,
    .el-calendar-table:not(.is-range) td.prev {
        color: #ccc;
        background-color: #15163d;
    }
    .el-calendar__button-group {
        width: 100%;
        background-color: #071150;
        vertical-align: middle;
        // display: none;
    }
    .el-calendar__header .el-calendar__header {
        display: none;
    }

    .el-button-group {
        display: flex;
        justify-content: space-between;
        background-color: #071150;
        color: #fff;
    }

    .el-button-group::after,
    .el-button-group::before {
        content: unset;
    }

    .el-button-group > .el-button:not(:first-child):not(:last-child) {
        display: none;
    }

    .el-button-group > .el-button:first-child:before {
        content: '<';
    }
    .el-button-group > .el-button:not(:last-child) {
        background: #071150;
        color: #fff;
        border: none;
        position: absolute;
        left: 44%;
        top: 20px;
        transform: translate(-44%);
    }
    .el-button-group > .el-button:not(:first-child) {
        background: #071150;
        color: #fff;
        border: none;
        position: absolute;
        right: 44%;
        top: 20px;
        transform: translate(44%);
    }

    .el-button-group > .el-button:last-child:before {
        content: '>';
    }
    .el-button--mini {
        font-size: 20px;
    }

    .el-button-group > .el-button:first-child span,
    .el-button-group > .el-button:last-child span {
        display: none;
    }
}
</style>
